import {
  Children,
  Fragment,
  type ExoticComponent,
  type PropsWithChildren,
  type ReactNode,
} from 'react';

import { isSlot } from '../../../../../core/utils/is-slot.js';
import { Graph } from '../slots/Graph.js';
import { Legend } from '../slots/Legend.js';
import { Provider } from '../slots/Provider.js';
import {
  type LegendProps,
  type ProviderSlotProp,
} from '../types/chart-layout.js';

/**
 * Function that selects legend and graph from children, and returns them identified.
 * @param children - Children for the ChartLayout. One should have the Graph area, and the other one the Legend area.
 * @returns An object with each children identified.
 */
export function extractLayoutSlots(children?: ReactNode) {
  let areas: {
    provider: ExoticComponent<PropsWithChildren> | ProviderSlotProp;
    legendArea?: ReactNode;
    legendProps?: LegendProps;
    graphArea?: ReactNode;
  } = {
    provider: Fragment,
  };

  Children.forEach(children, (child) => {
    if (isSlot(child, Graph)) {
      areas.graphArea = child.props.children;
    } else if (isSlot(child, Legend)) {
      areas.legendProps = child.props;
      areas.legendArea = child.props.children;
    } else if (isSlot(child, Provider)) {
      areas = {
        ...extractLayoutSlots(child.props.children),
        provider: child.props.provider,
      };
    }
  });

  return areas;
}
